import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { LocationProvider } from './contexts/Location';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { PublicSharedActivity } from './components/trail/PublicSharedActivity';
import { ViewModeProvider } from './contexts/ViewModeContext'; // Import ViewModeProvider
import { Toaster } from './components/ui/sonner';
import { Routes, Route } from 'react-router-dom';

// Public share pages render without the authenticated app shell.
const Root = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/share/')) {
    return (
      <AuthProvider>
        <Routes>
          <Route path="/share/:token" element={<PublicSharedActivity />} />
        </Routes>
      </AuthProvider>
    );
  }
  return (
    <AuthProvider>
      <LocationProvider>
        <ViewModeProvider>
          <App />
          <Toaster position="top-right" richColors />
        </ViewModeProvider>
      </LocationProvider>
    </AuthProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();